import { textConstructorDsAPI } from "@/views/ClientRequests/remontDS/dsCreationTemplates/changeTextConstructor/api";
import { downloadExcel } from "@/services";

export const getTextConstructorDsData = async (client_request_id, ds_id) => {
  try {
    const res = await textConstructorDsAPI.getTextConstructorMaterials(
      client_request_id,
      ds_id
    );
    const data = res?.data;
    if (!data?.length) return;

    // Prefer a single row per client_material_id when join duplicates exist
    // (e.g. leftover qty change + delete before tk_ds_delete fix).
    const deduped = dedupeTkConstructorRows(data);

    const materialCntData = {};
    deduped.forEach((item, index) => {
      const items = {};
      item.items_json?.forEach((child) => {
        items[child.material_id] = child.material_cnt;
      });
      materialCntData[index] = {
        // вместо item.client_material_id используем индекс
        material_cnt: item.material_cnt,
        items,
      };
    });

    return { data: deduped, materialCntData };
  } catch (e) {}
};

/** Collapse duplicate client_material rows (prefer delete action_type=1, else latest tk_change). */
export function dedupeTkConstructorRows(rows) {
  if (!rows?.length) return rows || [];
  const byKey = new Map();
  rows.forEach((row) => {
    const key =
      row.client_material_id && Number(row.client_material_id) > 0
        ? `cm-${row.client_material_id}`
        : `tk-${row.tk_change_id}`;
    const prev = byKey.get(key);
    if (!prev) {
      byKey.set(key, row);
      return;
    }
    const preferRow =
      row.action_type === 1 ||
      (prev.action_type !== 1 &&
        Number(row.tk_change_id || 0) >= Number(prev.tk_change_id || 0));
    if (preferRow) byKey.set(key, row);
  });
  return Array.from(byKey.values());
}

/** First save: full set; update: only deltas (SP deletes rows when cnt equals contract baseline). */
export function buildTkSetItemSaveArrays(baselineItems, currentItems, tkChangeId) {
  const cnt_material_id_arr = [];
  const cnt_material_cnt_arr = [];
  if (!currentItems) {
    return { cnt_material_id_arr, cnt_material_cnt_arr };
  }
  const isUpdate = Number(tkChangeId) > 0;
  if (!isUpdate) {
    Object.keys(currentItems).forEach((key) => {
      cnt_material_id_arr.push(Number(key));
      cnt_material_cnt_arr.push(Number(currentItems[key]));
    });
    return { cnt_material_id_arr, cnt_material_cnt_arr };
  }
  Object.keys(currentItems).forEach((key) => {
    const materialId = Number(key);
    const currentCnt = Number(currentItems[key]);
    const baselineCnt = baselineItems ? Number(baselineItems[materialId]) : NaN;
    if (currentCnt !== baselineCnt) {
      cnt_material_id_arr.push(materialId);
      cnt_material_cnt_arr.push(currentCnt);
    }
  });
  return { cnt_material_id_arr, cnt_material_cnt_arr };
}

export const getChangedMaterialsDsData = async (client_request_id, ds_id) => {
  try {
    const res = await textConstructorDsAPI.getChangedMaterials(
      client_request_id,
      ds_id
    );
    const data = res?.data;
    if (!data?.length) return;
    return data;
  } catch (e) {}
};

export const getTKRooms = async (client_request_id) => {
  try {
    const res = await textConstructorDsAPI.getRooms(client_request_id);
    return res?.data;
  } catch (e) {}
};

export const getTKWorkSets = async (client_request_id, room_id, ds_id) => {
  try {
    const res = await textConstructorDsAPI.getWorkSets(
      client_request_id,
      ds_id,
      room_id
    );
    return res?.data;
  } catch (e) {}
};

export const getMaterialPriceData = async (client_request_id, tk_change_id) => {
  try {
    const res = await textConstructorDsAPI.getMaterialPriceData(
      client_request_id,
      tk_change_id
    );
    return res;
  } catch (e) {}
};

export const changeMaterialPriceData = async (body) => {
  try {
    const res = await textConstructorDsAPI.changeMaterialPriceData(
      body.client_request_id,
      body
    );
    return res?.data;
  } catch (e) {}
};
export const printDsDoc = async (client_request_id, ds_id) => {
  try {
    const res = await textConstructorDsAPI.printDsDoc(client_request_id, ds_id);
    const currentTime = new Date().toLocaleTimeString("ru", {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    }); // Получаем время в формате HH:mm
    downloadExcel(res, `Измененные материалы ДС №${ds_id}`, currentTime);
  } catch (e) {}
};

export const addTKWork = async (body) => {
  try {
    const res = await textConstructorDsAPI.addWork(
      body.client_request_id,
      body
    );
    return res?.data;
  } catch (e) {}
};

export const getMCMaterials = async (client_request_id, body) => {
  try {
    const res = await textConstructorDsAPI.getMaterials(
      client_request_id,
      body,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return res?.data;
  } catch (e) {}
};

export const getMCRooms = async (client_request_id, body) => {
  try {
    const res = await textConstructorDsAPI.getRoomsMC(client_request_id, body, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return res?.data;
  } catch (e) {}
};

export const getMCWorkSets = async (client_request_id, body) => {
  try {
    const res = await textConstructorDsAPI.getWorkSetsMC(
      client_request_id,
      body,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return res?.data;
  } catch (e) {}
};

export const getMCMaterialSets = async (client_request_id, body) => {
  try {
    const res = await textConstructorDsAPI.getMaterialSet(
      client_request_id,
      body,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return res?.data;
  } catch (e) {}
};

export const addMCWork = async (body) => {
  try {
    const res = await textConstructorDsAPI.addMaterial(
      body.client_request_id,
      body
    );
    return res?.data;
  } catch (e) {}
};

export const modifyCancel = async (client_request_id, tk_change_id) => {
  try {
    const res = await textConstructorDsAPI.modifyCancel(
      client_request_id,
      tk_change_id
    );
    return res?.data;
  } catch (e) {}
};

export const materialDelete = async (client_request_id, body) => {
  try {
    const res = await textConstructorDsAPI.deleteMaterial(
      client_request_id,
      body,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return res?.data;
  } catch (e) {}
};

export const deleteCancel = async (client_request_id, body) => {
  try {
    const res = await textConstructorDsAPI.deleteCancel(
      client_request_id,
      body,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return res?.data;
  } catch (e) {}
};

export const saveMaterialCnt = async (client_request_id, body) => {
  try {
    const res = await textConstructorDsAPI.saveMaterialCount(
      client_request_id,
      body,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return res?.data;
  } catch (e) {}
};

export const parseQRData = async (client_request_id, qrData) => {
  try {
    const urlParts = qrData.split("/").filter(Boolean);
    const material_hash_id = urlParts.pop();
    const res = await textConstructorDsAPI.parseQRData(
      client_request_id,
      material_hash_id
    );
    return res?.data;
  } catch (e) {}
};
export const getQRWorkSet = async (client_request_id, material_id) => {
  try {
    const res = await textConstructorDsAPI.getQRWorkSet(
      client_request_id,
      material_id
    );
    return res?.data;
  } catch (e) {}
};
export const getQRRoom = async (
  client_request_id,
  material_id,
  work_set_id
) => {
  try {
    const res = await textConstructorDsAPI.getQRRoom(
      client_request_id,
      material_id,
      work_set_id
    );
    return res?.data;
  } catch (e) {}
};
export const getQRSet = async (
  client_request_id,
  material_id,
  work_set_id,
  room_id
) => {
  try {
    const res = await textConstructorDsAPI.getQRSet(
      client_request_id,
      material_id,
      work_set_id,
      room_id
    );
    return res?.data;
  } catch (e) {}
};
export const getReplacementMaterial = async (client_request_id, body) => {
  try {
    const res = await textConstructorDsAPI.getReplacementMaterial(
      client_request_id,
      body
    );
    return res?.data;
  } catch (e) {}
};
export const replaceMaterial = async (client_request_id, body) => {
  try {
    const res = await textConstructorDsAPI.replaceMaterial(
      client_request_id,
      body
    );
    return res?.data;
  } catch (e) {}
};

export const textConstructorColumns = [
  // действия — иконками в первой колонке (UI_GUIDE 4.3)
  { name: "actions", label: "", field: "actions", align: "left" },
  {
    name: "client_material_id",
    label: "ID",
    field: "client_material_id",
    align: "center",
    sortable: true,
  },
  {
    name: "room_name",
    label: "Комната",
    field: "room_name",
    align: "center",
    sortable: true,
  },
  {
    name: "material_name",
    label: "Материал",
    field: "material_name",
    align: "center",
    sortable: true,
  },
  {
    name: "material_cnt",
    label: "Кол-во",
    field: "material_cnt",
    align: "center",
    sortable: true,
  },
  {
    name: "unit_name",
    label: "Ед.изм",
    field: "unit_name",
    align: "center",
  },
  {
    name: "material_set_name",
    label: "Набор",
    field: "material_set_name",
    align: "center",
    sortable: true,
  },
  {
    name: "photo",
    label: "Фото набора/материала",
    field: "photo",
    align: "center",
  },
];

export const textConstructorMaterialsColumns = [
  {
    name: "material_id",
    label: "ID",
    field: "material_id",
    align: "center",
  },
  {
    name: "material_name",
    label: "Материал",
    field: "material_name",
    align: "left",
  },
  {
    name: "photo_url",
    label: "Фото",
    field: "photo_url",
    align: "center",
  },
  {
    name: "material_cnt",
    label: "Кол-во",
    field: "material_cnt",
    align: "right",
  },
  {
    name: "unit_name",
    label: "Ед.изм",
    field: "unit_name",
    align: "left",
  },
];

export const changedMaterialsColumns = [
  {
    name: "tk_change_id",
    label: "ID",
    field: "tk_change_id",
    align: "center",
    sortable: true,
  },
  {
    name: "room_name",
    label: "Комната",
    field: "room_name",
    align: "center",
    sortable: true,
  },
  {
    name: "work_set_name_old",
    label: "Старый конструктив",
    field: "work_set_name_old",
    align: "center",
    sortable: true,
  },
  {
    name: "material_name_old",
    label: "Старый материал",
    field: "material_name_old",
    align: "center",
    sortable: true,
  },
  {
    name: "material_set_name_old",
    label: "Старый набор",
    field: "material_set_name_old",
    align: "center",
    sortable: true,
  },
  {
    name: "photo_url_old",
    label: "Фото набора/материала (Старый)",
    field: "photo_url_old",
    align: "center",
  },
  {
    name: "price_old",
    label: "Старая цена",
    field: "price_old",
    align: "center",
    sortable: true,
  },
  {
    name: "work_set_name_new",
    label: "Замененный конструктив",
    field: "work_set_name_new",
    align: "center",
    sortable: true,
  },
  {
    name: "material_new_name",
    label: "Замененный материал",
    field: "material_new_name",
    align: "center",
    sortable: true,
  },
  {
    name: "material_set_name_new",
    label: "Набор",
    field: "material_set_name_new",
    align: "center",
    sortable: true,
  },
  {
    name: "photo_url_new",
    label: "Фото набора/материала (Новый)",
    field: "photo_url_new",
    align: "center",
  },
  {
    name: "price_new",
    label: "Новая цена",
    field: "price_new",
    align: "center",
    sortable: true,
  },
  {
    name: "price_diff",
    label: "Разница в цене",
    field: "price_diff",
    align: "center",
    sortable: true,
  },
  {
    name: "change_date",
    label: "Дата",
    field: "change_date",
    align: "center",
    sortable: true,
  },
  {
    name: "actions",
    label: "Действия",
    field: "actions",
    align: "center",
  },
];

export const changedMaterialsInnerColumns = [
  {
    name: "material_id",
    label: "ID",
    field: "material_id",
    align: "center",
  },
  {
    name: "material_name",
    label: "Материал",
    field: "material_name",
    align: "left",
  },
  {
    name: "photo_url",
    label: "Фото",
    field: "photo_url",
    align: "center",
  },
  {
    name: "material_cnt_old",
    label: "Кол-во (старый)",
    field: "material_cnt_old",
    align: "right",
  },
  {
    name: "material_cnt_new",
    label: "Кол-во (новый)",
    field: "material_cnt_new",
    align: "right",
  },
  {
    name: "unit_name",
    label: "Ед.изм",
    field: "unit_name",
    align: "left",
  },
];
export const getRowClass = (actionType, changes = false) => {
  if (changes) return "row-changed";
  switch (actionType) {
    case 1:
      return "row-red";
    case 2:
      return "row-green";
    case 3:
      return "row-orange";
    case 4:
      return "row-blue";
    default:
      return "";
  }
};
